import { render } from "./PaginationCart.vue?vue&type=template&id=ca4932e4"
import script from "./PaginationCart.vue?vue&type=script&lang=js"
export * from "./PaginationCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__